// extracted by mini-css-extract-plugin
export var cartContainer = "_mb-4";
export var gray = "_mb-1";
export var itemContainer = "_mb-2";
export var itemDetails = "_mb-3";
export var strong = "_mb-0";